
define('text!views/linkedaccounts/linkedcard.html',[],function () { return '<a href="#" class="js-edit-linked-account"> </a>\r\n\r\n<div class="linked-accounts-card-edit-form-container js-linked-accounts-card-edit-form-container"></div>\r\n';});

